<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMH"><span class="ePub-B">CONTENTS</span></p>
<p class="CCT"><span href="#/xhtml/title#tit" title="Link target outside of Sample">TITLE PAGE</span></p>
<p class="CCT"><span href="#/xhtml/copyrightnotice#cpyntc" title="Link target outside of Sample">COPYRIGHT NOTICE</span></p>
<p class="CCT__BOT"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">DEDICATION</span></p>
<p class="CCT">  <a href="#/xhtml/chapter1#ch1"><span class="ccn">1.</span>   LET ME FILL YOU IN</a></p>
<p class="CCT">  <a href="#/xhtml/chapter2#ch2"><span class="ccn">2.</span>   THE STARTING LIE</a></p>
<p class="CCT">  <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><span class="ccn">3.</span>   BLACKOUTS AND GLOW BANDS</span></p>
<p class="CCT">  <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><span class="ccn">4.</span>   STRANGE RELATIONS</span></p>
<p class="CCT">  <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><span class="ccn">5.</span>   FINDING THE BOOKS</span></p>
<p class="CCT">  <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><span class="ccn">6.</span>   ABANDONED</span></p>
<p class="CCT">  <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><span class="ccn">7.</span>   GLASSES HALF-FOOL</span></p>
<p class="CCT">  <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><span class="ccn">8.</span>   THE READ ALOUD</span></p>
<p class="CCT">  <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><span class="ccn">9.</span>   SURPRISE!</span></p>
<p class="CCT"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><span class="ccn">10.</span>   LIMO AND LIES</span></p>
<p class="CCT"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><span class="ccn">11.</span>   ALWAYS LET YOUR CONSCIENCE BE YOUR GUIDE</span></p>
<p class="CCT"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><span class="ccn">12.</span>   SOME BURIED PINOCULA</span></p>
<p class="CCT"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample"><span class="ccn">13.</span>   TRANSFORMATIONS AND WELCOME GUESTS</span></p>
<p class="CCT__BOT"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample"><span class="ccn">14.</span>   OPPORTUNITIES</span></p>
<p class="CCT"><span href="#/xhtml/tea#tea" title="Link target outside of Sample">TEASER</span></p>
<p class="CCT"><span href="#/xhtml/praise#pra" title="Link target outside of Sample">PRAISE FOR THE CREATURE FROM MY CLOSET SERIES</span></p>
<p class="CCT"><span href="#/xhtml/aboutauthor#abt" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
<p class="CCT"><span href="#/xhtml/copyright#cpy" title="Link target outside of Sample">COPYRIGHT</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?60fb6bf8